import { CancelRequestInterface } from '../interfaces/cancel-request.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CancelRequestModel')
export class CancelRequestModel implements CancelRequestInterface {
  @JsonProperty('SellPortfolio', Boolean)
  sellPortfolio: boolean = undefined;
}
